/**
 * Emit hosts for the `sessions` analytics group — 1 function
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  type CopySetting,
  type CopySettingsSnapshot,
} from '@/models/analytics/features/sessions';

/**
 * Fired when the user flips one of the four copy-formatting toggles.
 * `setting` + `is_enabled` capture what they changed it to;
 * `copySettings` is the full toggle state after the change.
 */
export function copySettingsUpdated(input: {
  setting: CopySetting;
  isEnabled: boolean;
  copySettings: CopySettingsSnapshot;
}) {
  track({
    event_name: TrackingEventName.CopySettingsUpdated,
    props: {
      setting: input.setting,
      is_enabled: input.isEnabled,
      copy_settings: input.copySettings,
    },
    options: { amplitude: false },
  });
}
